<template>
    <v-tooltip bottom color="black" nudge-bottom="2">
        <template v-slot:activator="{ on, attrs }">
            <v-progress-circular 
                :rotate="-90" 
                :size="40" 
                :width="4" 
                :value="progress" 
                :color="timerColor"
                class="mr-4 pomodoro-timer" 
                v-bind="attrs" 
                v-on="on"
                @click="toggleTimer"
                @mouseenter="showPlayPause = true"
                @mouseleave="showPlayPause = false">
                <v-icon 
                    :color="iconColor" 
                    small 
                    v-if="showPlayPause">
                    {{ isRunning ? 'mdi-pause' : 'mdi-play' }}
                </v-icon>
                <span v-else class="time-display">{{ timeDisplay }}</span>
            </v-progress-circular>
        </template>
        <span class="font-rubik font-weight-bold">{{ timerStateText }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'PomodoroTimer',
    props: {
        workDuration: {
            type: Number,
            default: 25 // minutos
        },
        breakDuration: {
            type: Number,
            default: 5 // minutos
        }
    },
    data() {
        return {
            isRunning: false,
            isBreak: false,
            timeRemaining: 0,
            totalTime: 0,
            timer: null,
            showPlayPause: false
        };
    },
    computed: {
        progress() {
            if (this.totalTime === 0) return 0;
            return 100 - ((this.timeRemaining / this.totalTime) * 100);
        },
        timeDisplay() {
            const minutes = Math.floor(this.timeRemaining / 60);
            const seconds = this.timeRemaining % 60;
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        },
        timerStateText() {
            if (!this.isRunning && this.timeRemaining === this.totalTime) {
                return "Iniciar pomodoro";
            }
            if (this.isBreak) {
                return `Descanso: ${this.timeDisplay}`;
            } else {
                return `Trabajo: ${this.timeDisplay}`;
            }
        },
        timerColor() {
            if (!this.isRunning) return 'grey';
            return this.isBreak ? 'light-green accent-3' : 'red accent-2';
        },
        iconColor() {
            if (this.isBreak) {
                return 'light-green accent-3';
            } else {
                return 'red accent-2';
            }
        }
    },
    mounted() {
        this.resetTimer();
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        resetTimer() {
            this.clearTimer();
            this.isBreak = false;
            this.timeRemaining = this.workDuration * 60;
            this.totalTime = this.workDuration * 60;
            this.isRunning = false;
        },
        toggleTimer() {
            if (this.isRunning) {
                this.pauseTimer();
            } else {
                this.startTimer();
            }
        },
        startTimer() {
            if (!this.isRunning) {
                this.isRunning = true;
                this.timer = setInterval(() => {
                    if (this.timeRemaining > 0) {
                        this.timeRemaining--;
                    } else {
                        this.switchMode();
                    }
                }, 1000);
            }
        },
        pauseTimer() {
            this.isRunning = false;
            this.clearTimer();
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        switchMode() {
            this.clearTimer();
            this.isBreak = !this.isBreak;
            
            if (this.isBreak) {
                this.timeRemaining = this.breakDuration * 60;
                this.totalTime = this.breakDuration * 60;
            } else {
                this.timeRemaining = this.workDuration * 60;
                this.totalTime = this.workDuration * 60;
            }
            
            // Emitir evento para notificar cambio de modo
            this.$emit('mode-changed', this.isBreak ? 'break' : 'work');
            
            // Continuar el temporizador automáticamente
            this.startTimer();
        }
    },
    watch: {
        workDuration() {
            if (!this.isBreak) {
                this.resetTimer();
            }
        },
        breakDuration() {
            if (this.isBreak) {
                this.timeRemaining = this.breakDuration * 60;
                this.totalTime = this.breakDuration * 60;
            }
        }
    }
}
</script>

<style scoped>
.pomodoro-timer {
    cursor: pointer;
    position: relative;
}

.pomodoro-timer:hover .time-display {
    display: none;
}

.time-display {
    font-size: 10px;
    font-weight: bold;
    color: white;
}

.pomodoro-timer:hover {
    opacity: 0.9;
}
</style> 